var render, staticRenderFns
import script from "./weChatReceive.vue?vue&type=script&lang=js"
export * from "./weChatReceive.vue?vue&type=script&lang=js"
import style0 from "./weChatReceive.vue?vue&type=style&index=0&id=3bba5cf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba5cf4",
  null
  
)

export default component.exports